<template>
  <div class="root">
    <div :style="styleMap" :class="classMap" class="cms-rich-wrap" ref="rich">
      <AppRichText :content="blok.content" class="cms-legacy" />
    </div>
  </div>

</template>

<script>
import cms from "@/mixins/cms.js";
import { renderRichText, storyblokInit, RichTextSchema } from "@storyblok/js";
// import cloneDeep from "clone-deep";

export default {
  mixins: [cms],
  name: "cms-rich-content",
  // created() {
  //   const mySchema = cloneDeep(RichTextSchema);
  //   storyblokInit({
  //     accessToken: this.$config.STORYBLOK_ACCESS_TOKEN,
  //     richText: {
  //       schema: mySchema,
  //       resolver: (component, blok) => {
  //         const style = this.extractCSS(blok)
  //         return `<component :blok='${JSON.stringify(blok)}' :is="'${component}'" class="component" :style='${JSON.stringify(style)}'></component>`;
  //       },
  //     },
  //   });
  // },
  mounted() {
    // Look for all elements that have an ID. If they have, assume an anchor has been set
    // via Storyblok. Add the 'anchor' class for padding at the top in order to prevent
    // the element from auto-scrolling in underneath the fixed header.
    const c = this.$refs.rich.querySelectorAll('*');
    [...c].forEach(el => {
      if (el.id) {
        el.classList.add('anchor')
      }
    })
    // const nodes = this.$refs.rich.querySelectorAll('p:not(:empty), h1, h2, h3, h4, h5, h6, ul, ol, blockquote');
    // [...nodes].forEach(n => {
    //   n.dataset.inspect = n.tagName.toLowerCase()
    // })
  },
  computed: {
    replacedContent() {
      let updated = this.renderRichText(this.blok.content);
      if (this.blok.pattern && this.blok.replacement) {
        updated = updated.replace(new RegExp(this.blok.pattern, 'g'), this.blok.replacement);
      }
      return `<div>${updated}</div>`;
    },
    classMap() {
      return {
        'place-left': this.blok.placement == "left",
        'place-right': this.blok.placement == "right",
      }
    },
    styleMap() {
      const map = { "xs": 300, "sm": 400, "md": 500, "lg": 600, "xl": 700, "xxl": 800, "xxxl": 900 };
      return {
        "--max_width": this.blok.max_char_width ? `${this.blok.max_char_width}ch` : "none",
        "--p_size": map[this.blok.p_size] != undefined ? `var(--fs-${map[this.blok.p_size]})` : null,
        "--h1_size": map[this.blok.h1_size] != undefined ? `var(--fs-${map[this.blok.h1_size]})` : null,
        "--h2_size": map[this.blok.h2_size] != undefined ? `var(--fs-${map[this.blok.h2_size]})` : null,
        "--h3_size": map[this.blok.h3_size] != undefined ? `var(--fs-${map[this.blok.h3_size]})` : null,
        "--h4_size": map[this.blok.h4_size] != undefined ? `var(--fs-${map[this.blok.h4_size]})` : null,
        "--h5_size": map[this.blok.h5_size] != undefined ? `var(--fs-${map[this.blok.h5_size]})` : null,
        "--h6_size": map[this.blok.h6_size] != undefined ? `var(--fs-${map[this.blok.h6_size]})` : null,
      }
    },
  },
}
</script>


<style>
.cms-rich-wrap {
  font-size: 0.9rem;
  word-wrap: break-word;
  margin: 0 auto 0 auto;
  transition: height 200ms ease-in;
  color: black;
  max-width: var(--max_width);
}

.cms-rich-wrap.place-left {
  margin: 0 auto 0 0;
}

.cms-rich-wrap.place-right {
  margin: 0 0 0 auto;
}

.cms-rich-wrap :is(h1, h2, h3, h4, h5, h6) {
  color: var(--color-primary);
  font-family: var(--font-brand);
  font-weight: 700;
}

.cms-rich-wrap :is(h1, h2, h3, h4, h5, h6) b {
  color: var(--color-primary);
}

.cms-rich-wrap h1 {
  font-size: var(--h1_size, var(--fs-600));
}

.cms-rich-wrap h2 {
  font-size: var(--h2_size, var(--fs-500));
}

.cms-rich-wrap h3 {
  font-size: var(--h3_size, var(--fs-400));
}

.cms-rich-wrap h4 {
  font-size: var(--h4_size, var(--fs-300));
}

.cms-rich-wrap h5 {
  font-size: var(--h5_size, var(--fs-300));
}

.cms-rich-wrap h6 {
  font-size: var(--h6_size, var(--fs-300));
}

.cms-rich-wrap p:last-child {
  margin-bottom: 0;
}

.cms-rich-wrap p:empty {
  /* Transparent border to hack margin-collapse */
  border: 1px dashed transparent;
  margin: 0.25rem 0;
}

.cms-rich-wrap :is(ul, ol) {
  list-style-type: disc;
  margin: 0;
  padding: 0 0 0 0.9rem;
}

.cms-rich-wrap :is(ul, ol) li {
  margin: 2px 0;
}

.cms-rich-wrap :is(ul, ol) p {
  margin: 0;
}

.cms-rich-wrap blockquote {
  font-style: italic;
  padding: 0.5rem 25px;
  /* border-left: 4px solid var(--color-accent); */
  line-height: 1.6;
  margin-block: 0.25rem 0;
  position: relative;
  background-color: transparent;
}

.cms-rich-wrap blockquote::before {
  font-family: Arial;
  content: "\201C";
  color: var(--color-accent);
  font-size: 3em;
  position: absolute;
  left: 0px;
  top: -10px;
}

.cms-rich-wrap p {
  font-size: var(--p_size, 0.9rem);
}

.cms-rich-wrap blockquote p {
  display: inline;
  font-size: 0.9rem;

}

.cms-rich-wrap img {
  max-width: 100%;
}

.cms-rich-wrap b,
.cms-rich-wrap strong {
  font-weight: 600;
  font-family: 'Inter';
  color: var(--color-primary);
}

.cms-rich-wrap a {
  color: var(--color-accent);
  text-decoration: none;
}

.cms-rich-wrap a:hover {
  text-decoration: underline;
}

.cms-rich-wrap hr {
  border: 0;
  height: 0;
  border-bottom: 1px solid var(--crf-border);
}

/* Padding for auto-scrolling to link with fixed header */
.cms-rich-wrap .anchor {
  /* padding-top: 80px; */
  /* margin-top: -80px; */
}
</style>
